import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { app, auth, db } from './firebase.config';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store} app={app} auth={auth} db={db} >
    <App/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

